import React from 'react';
import logo from './logo.svg';
import './App.css';
import { NavLink } from "react-router-dom";
import { Navbar, Container, Nav } from 'react-bootstrap'

import Footer from "./components/Layout/Footer"
import Header from "./components/Layout/Header"
import SideNav from "./components/Layout/SideNav"
import Home from "./pages/Home"
import MainLayout from './layouts/MainLayout';

function App() {
  return (
    <>
        {/*<Navbar bg="light" expand="lg">
        <Container>
          <Navbar.Brand>
            <NavLink to="/" style={{textDecoration: 'none', color: 'inherit'}}>Your account</NavLink>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <NavLink to="/address" className="nav-link">Address book</NavLink>
              <NavLink to="/orders" className="nav-link">Orders</NavLink>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      */}
AAAAA
      
    </>
  );
}

export default App;
